import React from 'react';

// The wordmark always renders left-to-right: SVG <text> follows the CSS
// direction, so under <html dir="rtl"> (fa) it would shift and clip.
// `adaptive` lightens the dark "Run" part under the app's dark theme (F21:
// it vanished on the dark navigation bar); pages with a fixed light
// background leave it off. `onDark` forces the light variant on
// always-dark surfaces such as the landing footers (X-05 / WH-32).
const Logo = ({ className = '', width = 200, height = 60, adaptive = false, onDark = false }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 200 60" 
      fill="none"
      width={width}
      height={height}
      className={className}
      style={{ direction: 'ltr' }}
    >
      <rect width="200" height="60" fill="transparent"/>
      <text x="20" y="40" fontFamily="'Poppins', sans-serif" fontSize="32" fontWeight="600" fill="currentColor"
        className={onDark ? 'text-gray-100' : adaptive ? 'text-[#2B2D42] dark:text-gray-100' : 'text-[#2B2D42]'}>Run</text>
      <text x="80" y="40" fontFamily="'Poppins', sans-serif" fontSize="32" fontWeight="700" fill="#EF233C">vya</text>
      <circle cx="10" cy="30" r="6" fill="#EF233C"/>
      <path d="M150 20 L180 30 L150 40 Z" fill="#8D99AE"/>
    </svg>
  );
};

export default Logo;